import http from "./http";

export const uploadFirmware = async (version, fwFile) => {
  try {
    const formData = new FormData();
    formData.append("version", version);
    formData.append("fw_file", fwFile);

    const res = await http.post("admin/upload_api.php", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res;
  } catch (error) {
    return { data: { status: "error", message: "Network Error: Could not connect to server" } };
  }
};
